module.exports = __webpack_public_path__ + "media/search/industrial_grayscale-2341ad39.png";